export default {
	data() {
		return {
			pageUrl: window.location.href
		};
	},
	created() {
		(function (d, s, id) {
			const fjs = d.getElementsByTagName(s)[0];
			if (d.getElementById(id)) return;
			const js = d.createElement(s);
			js.id = id;
			js.src = 'https://connect.facebook.net/hu_HU/sdk.js#xfbml=1&version=v2.11&appId=1544942269167304';
			fjs.parentNode.insertBefore(js, fjs);
		})(document, 'script', 'facebook-jssdk');
	}
};
